import lodash from 'lodash';
import { buildPagination } from './pagination';

const initialState = {
    $lastUpdateTime: undefined,
    isLoading: true,
    error: null,
    data: [],
    dataCount: 0,
    filters: {},
    pagination: buildPagination(),
};

export const buildState = (options) => {
    const $lastUpdateTime = Date.now();

    return lodash.merge({}, initialState, options, { $lastUpdateTime });
};



// WEBPACK FOOTER //
// ./src/common/factories/reduxState.js